import { render, staticRenderFns } from "./OptionChannels.vue?vue&type=template&id=7f857626"
import script from "./OptionChannels.vue?vue&type=script&lang=js"
export * from "./OptionChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports